/**
 * English strings for Account → Notification preferences.
 * Kept out of the main translation file to stay within the size gate.
 */
export const enNotificationPreferences = {
	title: "Notification Preferences",
	subtitle: "Configure which notifications you receive and how.",
	headers: {
		group: "Group",
		inApp: "In-app",
		email: "Email",
		digest: "Digest",
		frequency: "Frequency",
	},
	loading: "Loading preferences…",
	resetToDefaults: "Reset to defaults",
	colleagues: {
		inactive:
			"Switch on email or LinkedIn replies to colleagues above to choose whose replies you hear about.",
		noneSelected: "No colleague chosen yet, so no colleague's replies reach you.",
	},
};
